export function isOwnerWorkspacePath(pathname: string): boolean {
  return /^\/owner(?:\/|$)/.test(pathname);
}

export function isOwnerSignInPath(pathname: string): boolean {
  return pathname.replace(/\/+$/, '') === '/owner';
}

export function isOwnerPrivatePath(pathname: string): boolean {
  return isOwnerWorkspacePath(pathname) && !isOwnerSignInPath(pathname);
}
